import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import CommandPalette from "./CommandPalette";

function TopBar({ toggleSidebar }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showCommandPalette, setShowCommandPalette] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(3);

  const notifications = [
    {
      id: 1,
      title: "Nuevo comentario",
      message: "Carlos ha comentado en tu proyecto",
      time: "Hace 5 minutos",
      read: false
    },
    {
      id: 2,
      title: "Tarea completada",
      message: "La tarea \"Diseñar dashboard\" ha sido completada",
      time: "Hace 1 hora",
      read: false
    },
    {
      id: 3,
      title: "Recordatorio",
      message: "Tienes una reunión en 30 minutos",
      time: "Hace 2 horas",
      read: false
    },
    {
      id: 4,
      title: "Sistema actualizado",
      message: "WeMax ha sido actualizado a la versión 2.0",
      time: "Ayer",
      read: true
    }
  ];

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
    if (showUserMenu) setShowUserMenu(false);
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
    if (showNotifications) setShowNotifications(false);
  };

  const markAllAsRead = () => {
    setUnreadNotifications(0);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setShowCommandPalette(true);
      }
      if (e.key === "Escape") {
        setShowCommandPalette(false);
        setShowNotifications(false);
        setShowUserMenu(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <>
      <div className="flex bg-[#161616] border-b border-[#2a2a2a] h-16">
        {/* Mobile menu button */}
        <button
          className="md:hidden px-4 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#ff1b6d]"
          onClick={toggleSidebar}
        >
          <span className="sr-only">Open sidebar</span>
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Search bar */}
        <div className="flex-1 flex items-center justify-center px-4">
          <div className="w-full max-w-2xl">
            <label htmlFor="search" className="sr-only">Buscar</label>
            <div className="relative text-gray-400 focus-within:text-gray-600">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
              <button
                type="button"
                className="block w-full pl-10 pr-3 py-2 border border-[#2a2a2a] rounded-md leading-5 bg-[#1e1e1e] text-gray-300 placeholder-gray-400 focus:outline-none focus:bg-[#252525] focus:text-white sm:text-sm transition duration-150 ease-in-out"
                onClick={() => setShowCommandPalette(true)}
              >
                Buscar... <span className="ml-2 text-xs text-gray-500 hidden sm:inline-block">⌘K</span>
              </button>
            </div>
          </div>
        </div>

        <div className="flex items-center pr-4">
          {/* Notifications */}
          <div className="relative ml-4">
            <button
              className="flex items-center justify-center p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#161616] focus:ring-[#ff1b6d]"
              onClick={toggleNotifications}
            >
              <span className="sr-only">Ver notificaciones</span>
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
              </svg>
              {unreadNotifications > 0 && (
                <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-[#ff1b6d] ring-2 ring-[#161616]"></span>
              )}
            </button>

            {/* Notifications dropdown */}
            {showNotifications && (
              <div className="origin-top-right absolute right-0 mt-2 w-80 rounded-md shadow-lg bg-[#1e1e1e] ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                  <div className="flex items-center justify-between px-4 py-2 border-b border-[#2a2a2a]">
                    <span className="text-sm font-medium text-white">Notificaciones</span>
                    <button 
                      onClick={markAllAsRead}
                      className="text-xs text-[#ff1b6d] hover:text-[#ff1b6d]/80 focus:outline-none"
                    >
                      Marcar todas como leídas
                    </button>
                  </div>
                  
                  <div className="max-h-96 overflow-y-auto">
                    {notifications.map((notification) => (
                      <div 
                        key={notification.id} 
                        className={`px-4 py-3 hover:bg-[#252525] transition-colors duration-150 ${notification.read ? "" : "border-l-2 border-[#ff1b6d]"}`}
                      >
                        <div className="flex justify-between">
                          <p className="text-sm font-medium text-white">{notification.title}</p>
                          <p className="text-xs text-gray-400">{notification.time}</p>
                        </div>
                        <p className="text-sm text-gray-300 mt-1">{notification.message}</p>
                      </div>
                    ))}
                  </div>
                  
                  <div className="border-t border-[#2a2a2a] px-4 py-2">
                    <button className="text-sm text-center w-full text-[#ff1b6d] hover:text-[#ff1b6d]/80 focus:outline-none">
                      Ver todas las notificaciones
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Profile dropdown */}
          <div className="relative ml-4">
            <div>
              <button
                className="flex max-w-xs items-center rounded-full bg-[#161616] text-sm focus:outline-none focus:ring-2 focus:ring-[#ff1b6d] focus:ring-offset-2 focus:ring-offset-[#161616]"
                id="user-menu-button"
                onClick={toggleUserMenu}
              >
                <span className="sr-only">Abrir menú de usuario</span>
                <img
                  className="h-8 w-8 rounded-full"
                  src={user?.photoURL}
                  alt="Profile"
                />
              </button>
            </div>

            {showUserMenu && (
              <div 
                className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-[#1e1e1e] ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
              >
                <div className="px-4 py-2 border-b border-[#2a2a2a]">
                  <p className="text-sm font-medium text-white">{user?.name || user?.email}</p>
                  <p className="text-xs text-gray-400 truncate">{user?.email}</p>
                </div>
                <Link
                  to="/dashboard/profile"
                  className="block px-4 py-2 text-sm text-gray-300 hover:bg-[#252525]"
                  role="menuitem"
                  onClick={() => console.log("Profile link clicked")}
                >
                  Perfil
                </Link>
                <Link
                  to="/dashboard/profile?tab=security"
                  className="block px-4 py-2 text-sm text-gray-300 hover:bg-[#252525]"
                  role="menuitem"
                  onClick={() => console.log("Settings link clicked")}
                >
                  Configuración
                </Link>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-[#252525]"
                  role="menuitem"
                >
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Command Palette */}
      {showCommandPalette && (
        <CommandPalette 
          isOpen={showCommandPalette}
          setIsOpen={setShowCommandPalette}
        />
      )}
    </>
  );
}

export default TopBar;
